import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const dashboardData = async (bodyData) => {
  try {
    const res = await API.dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const plantHeadDashboardData = async (bodyData) => {
  try {
    const res = await API.plant_head_dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const supervisorDashboardData = async (bodyData) => {
  try {
    const res = await API.supervisor_dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const planningDashboardData = async (bodyData) => {
  try {
    const res = await API.planning_dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const ieDashboardData = async (bodyData) => {
  try {
    const res = await API.ie_dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const adminDashboardData = async (bodyData) => {
  try {
    const res = await API.admin_dashboard_data(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};